import { services } from "../data/content";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { site } from "../data/content";
import { motion } from "framer-motion";
import { ServiceIcon } from "../components/ServiceIcons";

export default function Services() {
  return (
    <div className="pt-28 pb-24">
      <section className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="overline">Services</div>
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl mt-4 leading-[1.02] max-w-4xl" style={{ color: "var(--primary)" }}>
          What I do <span style={{ color: "var(--accent)", fontStyle: "italic" }}>— and how I work</span>.
        </h1>
        <p className="mt-6 max-w-2xl text-base md:text-lg" style={{ color: "var(--text-secondary)" }}>
          Eight focused practices, built on <mark className="hl">$13.7 B+</mark> of delivered projects across{" "}
          <mark className="hl">15 countries</mark>. Most engagements are scoped as 4–12 week sprints or retained advisory.
        </p>
      </section>

      <section data-testid="services-grid" className="mt-16 max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-px" style={{ backgroundColor: "var(--border-soft)" }}>
        {services.map((s, i) => (
          <motion.article
            key={s.title}
            data-testid={`service-${i}`}
            className="relative overflow-hidden p-8 md:p-10 group"
            style={{ backgroundColor: "var(--bg)" }}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: i * 0.05, ease: "easeOut" }}
            whileHover={{ y: -3 }}
          >
            {/* giant italic numeral watermark */}
            <span
              aria-hidden="true"
              className="absolute right-4 bottom-0 font-serif pointer-events-none select-none transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1"
              style={{ fontStyle: "italic", color: "var(--border-soft)", opacity: 0.55, fontSize: "10rem", lineHeight: 0.8 }}
            >
              {String(i + 1).padStart(2, "0")}
            </span>

            {/* top border accent that slides in on hover */}
            <span className="absolute top-0 left-0 h-[2px] bg-[var(--accent)] w-0 group-hover:w-full transition-all duration-500" />

            <div className="relative z-10 flex items-start justify-between gap-4">
              <div className="service-icon" style={{ color: "var(--primary)" }}>
                <ServiceIcon name={s.icon} />
              </div>
              <span className="font-mono text-[11px] uppercase tracking-widest font-semibold" style={{ color: "var(--accent-strong)" }}>
                0{i + 1}
              </span>
            </div>
            <h2 className="relative z-10 font-serif text-2xl md:text-3xl mt-8 leading-tight" style={{ color: "var(--primary)" }}>
              {s.title}
            </h2>
            <p className="relative z-10 mt-4 text-sm md:text-base leading-relaxed" style={{ color: "var(--text-secondary)" }}>
              {s.summary}
            </p>
          </motion.article>
        ))}
      </section>

      <section className="mt-24 max-w-7xl mx-auto px-6 md:px-12">
        <div className="p-10 md:p-14 grain-overlay relative" style={{ backgroundColor: "var(--primary)", color: "var(--bg)" }}>
          <div className="relative z-10 grid md:grid-cols-2 gap-8 items-end">
            <div>
              <div className="overline" style={{ color: "var(--accent-soft)" }}>How to start</div>
              <h2 className="font-serif text-4xl md:text-5xl mt-3 leading-tight">A single email is enough.</h2>
              <p className="mt-6 text-base md:text-lg" style={{ color: "rgba(244,243,240,0.82)" }}>
                Describe the problem. I&apos;ll reply with a short view on shape, scope and fee — usually within 48 hours.
              </p>
            </div>
            <div className="md:text-right">
              <Link
                to="/contact"
                data-testid="services-cta"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm"
                style={{ backgroundColor: "var(--accent)", color: "var(--primary)" }}
              >
                Start a conversation <ArrowRight size={16} />
              </Link>
              <div className="mt-4 text-xs font-mono" style={{ color: "rgba(244,243,240,0.65)" }}>
                {site.email}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
